module.exports = {
  hasHeader: true,
}



// WEBPACK FOOTER //
// ./config/projectConfig.js